// extracted by mini-css-extract-plugin
module.exports = {"valuePropsContainer":"value-prop-header_valuePropsContainer__3h9Qo","tripleValueProp":"value-prop-header_tripleValueProp__3S_10"};